import api from "../Utils/axios";
import { adminV1Base } from "../Utils/connection_strings";
import { filterParams } from "../Utils/helpers";

export const getCancellationReasons = (page, perPage, search_string, status, from, to) => {
    return api.get(`${adminV1Base}/cancellation-reason/get`, {
        params: filterParams({
            page,
            limit: perPage,
            keyword: search_string,
            active: status,
            "createdAt[from]": from,
            "createdAt[to]": to,
        }),
    });
};

export const getCancellationReasonDetails = (id) => {
    return api.get(`${adminV1Base}/cancellation-reason/get`, {
        params: {
            _id: id,
        },
    });
};

export const createCancellationReason = (data) => {
    return api.post(`${adminV1Base}/cancellation-reason/create`, data);
};

export const editCancellationReason = (data) => {
    return api.post(`${adminV1Base}/cancellation-reason/edit`, data);
};

export const handleCancellationReasonStatus = (id) => {
    return api.post(`${adminV1Base}/cancellation-reason/handle-status`, { id });
};

export const deleteCancellationReason = (id) => {
    return api.post(`${adminV1Base}/cancellation-reason/delete`, { id });
};
